import React from 'react';
import {DataTable} from 'primereact/datatable';
import { sendRequest } from '../../utils/request';
import TextInput from './TextInput';

const editors = {
	"text": (props,field) => {
		return <TextInput name="id" value={ props.rowData[field]} />;
	}
};

class List extends React.Component {
	constructor(props, field) {
		super(props);
		/*this.state = {
			data: {
				rows: [],
				cols: []
			}
		};*/
		this.getData.bind(this);
	}


	handleChange() {

	}

	getData() {
		const tabledef = {
			rows: [],
			cols: []
		}
	}

	render() {
		if(this.props.show) {
			const {cols, rows} = this.getData();
			<div className="listWrapper">
				<DataTable
					ref={(el) => this.dt = el}
					value={this.state.data.rows}
					editable={true}
					selectionMode="single"
					selection={ this.state.selection && this.state.selection.id==this.props.selected ? this.state.selection : null}
					emptyMessage=""
					onSelectionChange={ (selection)=>{ this.setState({selection: selection.value}); this.props.formLoader(selection.value.id); } }
				>
					{ this.props.cols.map((col,idx)=>{
						return <Column
								key={idx}
								field={ col.field }
								header={ col.header || null }
								body={ col.renderer }
								editor={ (props) => (col.editor(props, col.field)) }
								className={ col.className }
							/>
						}
					)}
				</DataTable>
			</div>

		} else {
			return null;
		}
	}

}

export default List;